import env from 'env';

const AuthSupport = () => (
  <p className="text-center text-sm text-muted-foreground mt-6">
    Having trouble?{' '}
    <a href={`mailto:${env.CODEKEEPER_SERVICE_EMAIL}`} className="text-secondary-foreground font-bold">
      Contact support
    </a>
  </p>
);

export default AuthSupport;
